import { KPI_HISTORIA } from "../data/demoData";
import Card from "../components/ui/Card";
import SectionHeader from "../components/ui/SectionHeader";
import Sparkline from "../components/ui/Sparkline";

export default function ModuloKPIs() {
  const kpis = [
    { label: "Tasa de confirmación", valor: 83, objetivo: 80, unidad: "%" },
    { label: "Tiempo promedio reparación", valor: 5.1, objetivo: 5, unidad: " días" },
    { label: "Cumplimiento ANMAT", valor: 100, objetivo: 100, unidad: "%" },
    { label: "Alertas resueltas < 24h", valor: 91, objetivo: 95, unidad: "%" },
  ];

  return (
    <div>
      <SectionHeader title="KPIs y métricas de desempeño" />
      <div className="grid grid--4 gap-3 mb-5">
        {kpis.map(k => {
          const ok = k.unidad === " días" ? k.valor <= k.objetivo : k.valor >= k.objetivo;
          const porcentaje = Math.min((k.valor / (k.objetivo * 1.2)) * 100, 100);
          return (
            <Card key={k.label}>
              <p className="text-sm text-muted mb-0">{k.label}</p>
              <p className={`text-3xl font-semibold my-1 ${ok ? "text-success" : "text-warning"}`}>{k.valor}{k.unidad}</p>
              <div className="progress-mini"><div className={`progress-mini__bar ${ok ? "progress-mini__bar--success" : "progress-mini__bar--warning"}`} style={{ width: `${porcentaje}%` }} /></div>
              <p className="text-xs text-muted mb-0">Objetivo: {k.objetivo}{k.unidad} · {ok ? "✓ Cumplido" : "⚠ Por debajo"}</p>
            </Card>
          );
        })}
      </div>
      <Card>
        <p className="font-semibold mb-3">Evolución histórica (6 meses)</p>
        <div className="grid grid--2 gap-4">
          <div>
            <p className="text-xs text-muted mb-1">Tasa de confirmación (%)</p>
            <Sparkline data={KPI_HISTORIA.map(k => k.tasa)} height={60} />
            <div className="flex justify-between mt-1">{KPI_HISTORIA.map(k => <span key={k.mes} className="text-xs text-muted">{k.mes}</span>)}</div>
          </div>
          <div>
            <p className="text-xs text-muted mb-1">Tiempo promedio reparación (días)</p>
            <Sparkline data={KPI_HISTORIA.map(k => k.tiempo)} color="warning" height={60} />
            <div className="flex justify-between mt-1">{KPI_HISTORIA.map(k => <span key={k.mes} className="text-xs text-muted">{k.mes}</span>)}</div>
          </div>
        </div>
      </Card>
      <Card className="mt-4">
        <p className="font-semibold mb-2">Predicción próximos 30 días</p>
        <div className="alert alert--success mb-2"><p className="mb-0">✓ Tasa de confirmación proyectada: <strong>86%</strong> (sobre objetivo 80%)</p></div>
        <div className="alert alert--warning"><p className="mb-0">⚠ Tiempo promedio proyectado: <strong>5.4 días</strong> (leve alza — monitorear)</p></div>
      </Card>
    </div>
  );
}